import * as React from 'react';
import { throwIfWrong } from '../../model/Assets';
import Screens from '../../model/Screens';
import { MachineContext } from '../fsm/useMachine';
import { getAllFlowInfo } from '../utils/getInfo';
import {Printer} from "react-feather";

export const Export = () => {
    const [current,] = React.useContext(MachineContext)

    const { string_id } = getAllFlowInfo();

    const imageToHtml = (image: string) => `<html><style>body {height: 100%;width: 100%;padding: 0;margin: 0;}img {width: 100vw;margin: 0 auto;}</style><img src="${image}" /></html>`


    return (
        <button className="empty" title="Export to PDF" onClick={async (e) => {
            e.preventDefault()
            e.stopPropagation()
            let toSend = current.context.flow.screens.map((screen: Screens) => {
                return imageToHtml(screen.previewScreenShot.externalURL.value as string)
            })
            await fetch(`/flow/${string_id}/htmltopdf`, { method: "POST", body: JSON.stringify(toSend) })
                .then(r => r.blob())
                .then(blob => {
                    let file = new File([blob], `${current.context.flow.title}.pdf`)
                    let url = window.URL.createObjectURL(file)
                    let a = document.createElement('a')
                    a.href = url
                    a.target = '_blank'
                    a.rel = 'noopener'
                    let _, sUsrAg = navigator.userAgent;
                    if (sUsrAg.indexOf("Firefox") <= -1) {
                        a.download = `${current.context.flow.title}.pdf`
                    }
                    document.body.appendChild(a) // we need to append the element to the dom -> otherwise it will not work in firefox
                    a.click()
                    // For Firefox it is necessary to delay revoking the ObjectURL.
                    setTimeout(() => { window.URL.revokeObjectURL(url); }, 250);
                    a.remove()  //afterwards we remove the element again         

                });
        }}>
            <Printer className="feather" />
        </button >
    )
}
